import { Component } from '@angular/core';

import { Whitelist, WhitelistService } from './whitelist.service';
import { TableColumn } from '../wsusage/wsusage.component';

import { Fmt } from '../../fmt.service';
import { Auth } from '../../auth.service';

@Component({
    selector: 'whitelist',
    templateUrl: './whitelist.component.html',
    styleUrls: ['./../app/app.component.css'],
    providers: [
        Fmt,
        WhitelistService
    ]
})
export class WhitelistComponent {
    public whitelists: any[];
    public tempWhitelist: any[] = [];

    public tableMode: string = 'view';

    constructor (
        public _whiteListService: WhitelistService,
        public _fmt: Fmt
    ) {

        this.initWhitelist(() => {});
    }

    public tableColumns: TableColumn[] =  [
        {name: 'No.', key: 'id', editable: false}
        , {name: 'メールアドレス', key: 'email', editable: true}
        // , {name: 'Created At', key: 'created_at', editable: false}
    ];

    initWhitelist(callback: () => void) {
        this._whiteListService.LoadWhitelists<Array<any>>().subscribe(
            data => {
                let jsonData = data;
                this.whitelists = jsonData;
                callback();
            }
        )
    }

    addWhitelistRow() {
        this.whitelists.unshift(<Object>{
            'id': this.getLastElementID()+1,
            'email': '',
            'newItem': true
        });
    }

    editWhiteList(viewMode: string) {
        this.initWhitelist(() => {
            this.tableMode = viewMode;
        })
    }

    cancelEditWhitelist(viewMode: string) {
        this.initWhitelist(() => {
            this.tableMode = viewMode;
        })
    }

    save(viewMode: string) {
        this.validateInputs((formErr) => {
            if(!formErr) {
                this._whiteListService.ClearSupervisorCache().subscribe(
                    resp => {
                        console.log(resp);
                    },
                    err => {}
                ); // clear supvervisor cache
                
                this._whiteListService.SaveWhitelist(this.whitelists).subscribe(
                    resp => {
                        this.initWhitelist(() => {
                            this.tableMode = viewMode;
                        })
                    },
                    err => {}
                )
            }
        });
    }

    validateInputs(callback: (hasError: boolean) => void) {
        var formErr: boolean = false;
        for (let index in this.whitelists) {
            let email = this.whitelists[index]['email'];

            // if(email == '') {
            //     this.whitelists[index]['error'] = true
            //     this.whitelists[index]['error_msg'] = 'empty'
            //     this.whitelists[index]['error_level'] = 'has-warning'
            //     formErr = true;
            //     continue;
            // }

            if(email != '' && !this._fmt.validateEmail(email)) {
                this.whitelists[index]['error'] = true;
                this.whitelists[index]['error_msg'] = 'invalid';
                this.whitelists[index]['error_level'] = 'has-error'
                
                formErr = true;
                continue;
            }

            this.whitelists[index]['error'] = false;
        }

        callback(formErr);

    }

    getLastElementID(): number {
        return this.whitelists[0]['id']
    }
}